import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Tengo que renunciar para que esto funcione?',
    a: 'No, la guía está diseñada para que recuperes la paz en tu puesto actual.'
  }, {
    q: '¿Sirve si trabajo remoto?',
    a: 'Sí, el blindaje digital es incluso más necesario cuando la oficina está en tu casa.'
  }, {
    q: '¿Es difícil de aplicar?',
    a: 'Son cambios de lenguaje y conducta pequeños que generan resultados inmediatos.'
  }, {
    q: '¿Mi jefe se va a dar cuenta?',
    a: 'No, el método es táctico y sutil; simplemente vas a parecer más profesional y menos reactivo.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-light-bg text-text-light py-20 md:py-28" data-id="element-26">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-27">
        <FadeIn data-id="element-28">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-12 text-primary-dark" data-id="element-29">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-30">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-31">
              <div className={`bg-white border rounded-xl overflow-hidden transition-all duration-300 ${openIndex === index ? 'border-accent shadow-md' : 'border-gray-200 hover:border-accent/50'}`} data-id="element-32">
                <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-33">
                  <span className="font-bold text-lg text-primary-dark" data-id="element-34">
                    {faq.q}
                  </span>
                  <ChevronDown className={`text-accent transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-35" />
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-36">
                  <p className="text-text-muted text-lg leading-relaxed" data-id="element-37">
                    {faq.a}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}